import React from 'react'
import { FieldLabel } from '../form/index'
import ServiceMappingSearchSelect from './ServiceMappingSearchSelect'

const ServiceMappingSearchSelectField = (props) => (
  <FieldLabel {...props} format={null} component={ServiceMappingSearchSelect} />
)

export default ServiceMappingSearchSelectField
